import { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';
export function useVisibility(kind: 'blog' | 'membership') {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let active = true;
    const refresh = () => apiFetch<{data:{visible:boolean}}>(`/settings/${kind}-visibility`)
      .then(result => { if(active) setVisible(result.data.visible !== false); })
      .catch(() => { if(active) setVisible(false); });
    void refresh();
    window.addEventListener('focus',refresh);
    return () => { active=false; window.removeEventListener('focus',refresh); };
  },[kind]);
  return visible;
}
